class BuildPageConfirmCtrl {
  constructor(UrlClipCopy, TBService, FlashService) {
    'ngInject';
    this.UrlClipCopy = UrlClipCopy;
    this.tb = TBService;
    this.fs = FlashService;
    this.loading = true;
    this.buildPageUrl = '';
  }

  async $onInit() {
    if (!this.template?.appId) {
      this.fs.error('Please select an application.');
      this.cancel();
      return;
    }

    try {
      const response = await this.tb.publishPage(this.template);
      if (response.data?.success) {
        this.buildPageUrl = response.data.buildPageUrl;
        this.loading = false;
        return;
      }
      this.fs.error('There was an error publishing the page to the provider!');
      this.cancel();
    } catch (_error) {
      this.fs.error('There was an error publishing the page to the provider!');
      this.cancel();
    }
  }

  cancel() {
    this.onCancel();
  }

  copy() {
    this.UrlClipCopy.copy(this.buildPageUrl);
  }
}

export default {
  bindings: {
    template: '<',
    onCancel: '&',
  },
  templateUrl: 'form-builder/build-wizard/build-page-confirm/build-page-confirm.component.html',
  controller: BuildPageConfirmCtrl,
};
